import {cs} from "../../react/chain-services";
import {UseState} from "../../react/use-state";
import {stateChangeNestedValue} from "../../react/state-change-nested-value";
import {Static2} from "../../react/static-2";
import {fragments} from "../../react/fragments";
import {OnUpdated} from "../../react/on-updated";
import {OnMounted} from "../../react/on-mounted";

export const KeyboardSearchController = ({renderListItem, getList, onSelect, onClose, next}) => cs(
    ["state", (_, next) => UseState({initValue: {
        searching: null,
        focusedIndex: null,
        defaultCount: 50,
        count: 50,
    }, next})],
    ["listRef", (_, next) => Static2({next})],
    ["focusedRef", (_, next) => Static2({next})],
    ({state, focusedRef, listRef}) => fragments(
        next({
            searching: {
                value: state.value.searching,
                onChange: (s) => {
                    state.onChange(!s ? {
                        searching: null,
                        focusedIndex: null,
                        defaultCount: 50,
                        count: 50,
                    } : {
                        searching: s,
                        focusedIndex: 0,
                        defaultCount: 50,
                        count: 50,
                    });
                },
            },
            renderList: () => {
                return getList(state.value.searching)?.slice(0,state.value.count).map((item, i) => {
                    const focused = state.value.focusedIndex === i;
                    return renderListItem(item, {
                        index: i, focused,
                        ...focused && {
                            ref: focusedRef.set,
                        },
                    });
                })
            },
            keyDown: (e) => {
                if (e.key === "Escape") {
                    if (state.value.searching) {
                        state.onChange({
                            searching: null,
                            focusedIndex: null,
                            defaultCount: 50,
                            count: 50,
                        });
                    } else {
                        onClose();
                    }
                    return true;
                } else if (e.key === "ArrowDown") {
                    stateChangeNestedValue(state, ["focusedIndex"], (focusedIndex) => {
                        let i = (focusedIndex ?? -1) + 1;

                        if (i >= getList(state.value.searching).length) {
                            // i = 0;
                            i --;
                        }
                        return i;
                    })
                    return true;
                } else if (e.key === "ArrowUp") {
                    stateChangeNestedValue(state, ["focusedIndex"], (focusedIndex) => {
                        let i = (focusedIndex ?? 0) - 1;

                        if (i < 0) {
                            // i = getList(state.value.searching).length - 1;
                            i ++;
                        }
                        return i;
                    })
                    return true;
                } else if (e.key === "Home") {
                    stateChangeNestedValue(state, ["focusedIndex"], () => 0);
                    return true;
                } else if (e.key === "End") {
                    stateChangeNestedValue(state, ["focusedIndex"], () => getList(state.value.searching).length - 1);
                    return true;
                } else if (e.key === "Enter") {
                    if (state.value.focusedIndex != null) {
                        const item = getList(state.value.searching)[state.value.focusedIndex];
                        item && onSelect(item);
                    }
                    return true;
                }
            },
            checkAddScroll: (e) => {
                const bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 10; // 10px threshold from bottom
                if (bottom) {
                    stateChangeNestedValue(state, ["focusedIndex"], () => state.value.count - 1);
                    stateChangeNestedValue(state, ["count"], () => state.value.count + state.value.defaultCount);
                }
            },
            listRef: listRef.set,
        }),

        state.value.focusedIndex != null && (() => {

            const checkScroll = () => {
                const itemDom = focusedRef.get();
                if (!itemDom) {
                    return;
                }

                const listDom = listRef.get();

                const itemRect = itemDom.getBoundingClientRect();
                const listRect = listDom.getBoundingClientRect();

                if (listRect.y > itemRect.y - 20) {
                    listDom.scrollTop -= listRect.y - (itemRect.y - 20);
                } else if (listRect.y + listRect.height < itemRect.y + itemRect.height + 20) {
                    listDom.scrollTop += itemRect.y + itemRect.height + 20 - (listRect.y + listRect.height);
                }

                // itemDom.scrollIntoView();
            };
            return fragments(
                OnMounted({
                    action: checkScroll,
                }),
                OnUpdated({
                    action: checkScroll,
                }),
            )
        })()
    ),
);
